import moment from 'moment';
import 'angular-bootstrap-calendar';

import 'Sass/views/academic-calendar.scss';

(function () {
    'use strict';

    function ctrl($window, calendarService, calendarEventTitle) {

        const filters = ['semester', 'session', 'trimester'];

        let t; // ??
        let r; // ??
        let master = [];

        this.loading = true;

        const ical = () => $window.open(`/webapi/icsservice/get/${this.filterVal || 'Semester'}`, '_self', '');
        const icalSingle = id => $window.open(`/webapi/icsservice/getevent?id=${id}&eventType=Academic Calendar`, '_self', '');

        const filter = filterVal => {

            this.filterVal = filterVal || '';
            this.events = master.filter(v => {

                t = v.title.toLowerCase();
                r = t.indexOf(this.filterVal.toLowerCase()) !== -1;

                if (!r) {
                    // if the title contains no filters, treat it as generic and include in the result set
                    // only check if r is false, just to save on overhead
                    r = filters
                        .map(f => t.indexOf(f))
                        .reduce((sum, val) => sum + val, 0) === filters.length * -1;
                }

                if (r) {
                    return v;
                }
            });
        }

        // override tooltips for events
        calendarEventTitle.monthViewTooltip = e => e.title;

        // disable tooltips in week/day view - not displaying day view, but clearing it regardless
        calendarEventTitle.weekViewTooltip = calendarEventTitle.dayViewTooltip = () => '';

        // get the data, then ensure start/end dates are js date objects
        // keep a copy for filtering
        calendarService.get()
            .then(resp => {
                resp.data.forEach(v => {
                    const start = moment(v.startsAt);
                    const end = moment(v.endsAt);
                    const multi = !start.isSame(end);

                    v.cssClass += multi ? ' multiday' : '';
                    v.multiDay = multi ? 1 : 0;
                    v.startsAt = start.toDate();
                    v.endsAt = end.toDate();

                    v.actions = [{
                        label: '<i class="fa fa-cloud-download" name="Download iCal event"></i>',
                        cssClass: 'event-action-link',
                        onClick: args => icalSingle(args.calendarEvent.id)
                    }];

                });
                master = resp.data;

                this.events = resp.data;
                filter('Semester');
                this.loading = false;
            });

        this.cellIsOpen = true;

        angular.extend(this, {
            calendarView: 'month',
            viewDate: new Date(),

            filter: filter,
            ical: ical,
            icalSingle: icalSingle
        });

    }

    /*
     * the data service - it's a simple one, let's just keep it here
     */
    function service($http) {
        return {
            get: () => $http.get('/webapi/calendarservice/get').then(result => result.data)
        }
    };

    // inject ui.calendar dep to Uscapp module
    angular.module('Uscapp').requires.push('mwl.calendar');
    angular.module('Uscapp').factory('calendarService', ['$http', service]);
    angular.module('Uscapp').controller('calendar.controller', ['$window', 'calendarService', 'calendarEventTitle', ctrl]);
}());